import React, { useEffect, useState } from "react";
import { Container, Image, Spinner, Table } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import {
  MdOutlineEdit,
  MdDeleteOutline,
  MdAddCircleOutline,
  MdOutlineWorkspaces,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { apiGetMarques, apiUpdateMarque } from "../../api/ApiMarque";
import ModalCreateUpdate from "../../components/admin/marque/ModalCreateUpdate";
import ModalDelete from "../../components/admin/marque/ModalDelete";
import { ImStarEmpty, ImStarFull } from "react-icons/im";
import { useTranslation } from "react-i18next";

const PageAdminMarques = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [marques, setMarques] = useState([]);
  const [idMarque, setIdMarque] = useState("");

  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    recupMarques();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleShowCreateUpdate = (id) => {
    setIdMarque(id);
    setShowCreateUpdate(true);
  };

  const handleCloseCreateUpdate = () => {
    setIdMarque(null);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdMarque(id);
    setShowDelete(true);
  };
  const handleCloseDelete = () => {
    setIdMarque(null);
    setShowDelete(false);
  };

  const recupMarques = async () => {
    setLoading(true);
    const res = await apiGetMarques(ReduxInstance._id);
    if (res) {
      setMarques(res.data);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  const handlePinOrganisation = async (organisationId, action) => {
    const formData = { pinned: action };
    await apiUpdateMarque(organisationId, formData);
    recupMarques();
  };

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminMarques.titre")} />
        <span role="button" onClick={() => handleShowCreateUpdate("")}>
          <MdAddCircleOutline size="1.5em" />{" "}
          {t("admin.PageAdminMarques.buttonAjouterOrganisation")}
        </span>
        {loading ? (
          <div style={{ textAlign: "center", flex: 1 }}>
            <Spinner animation="grow" />
          </div>
        ) : (
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr>
                <th>{t("admin.PageAdminMarques.titreColonne1")}</th>
                <th className="text-center">{t("admin.PageAdminMarques.titreColonne2")}</th>
                <th className="text-center">{t("admin.PageAdminMarques.titreColonne3")}</th>
                <th className="text-center">{t("admin.PageAdminMarques.titreColonne4")}</th>
              </tr>
            </thead>
            <tbody>
              {marques.map((marque) => (
                <tr key={marque._id}>
                  <td>
                    {marque.marquePic && (
                      <Image
                        src={
                          process.env.REACT_APP_URL_EXPRESS + "images/marque/" + marque.marquePic
                        }
                        width={75}
                        className="me-1"
                      />
                    )}
                    {marque.nom}
                  </td>
                  <td className="text-center">
                    {marque.pinned ? (
                      <ImStarFull
                        size="1.5em"
                        role="button"
                        onClick={() => handlePinOrganisation(marque._id, false)}
                      />
                    ) : (
                      <ImStarEmpty
                        size="1.5em"
                        role="button"
                        onClick={() => handlePinOrganisation(marque._id, true)}
                      />
                    )}
                  </td>
                  <td className="text-center">
                    <MdOutlineEdit
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowCreateUpdate(marque._id)}
                    />
                  </td>
                  <td className="text-center">
                    <MdDeleteOutline
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowDelete(marque._id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        <ModalCreateUpdate
          show={showCreateUpdate}
          id={idMarque}
          handleClose={handleCloseCreateUpdate}
          handleRecupDatas={recupMarques}
        />
        <ModalDelete
          show={showDelete}
          id={idMarque}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupMarques}
        />
      </Container>
    </>
  );
};

export default PageAdminMarques;
